/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * The reason why a data value cannot be edited.
 */

/**
 * The reason why an item cannot be removed.
 */

export let CollectionItemChangeState = /*#__PURE__*/function (CollectionItemChangeState) {
  CollectionItemChangeState["ADDED"] = "added";
  CollectionItemChangeState["UPDATED"] = "updated";
  CollectionItemChangeState["REMOVED"] = "removed";
  return CollectionItemChangeState;
}({});

/**
 * The type of an item in a collection data value.
 */

/**
 * The interface implemented by all vector properties.
 */

export function isScalarAccessor(accessor) {
  return typeof accessor === "object" && accessor !== null && "getClientValue" in accessor;
}
export function isCollectionAccessor(accessor) {
  return typeof accessor === "object" && accessor !== null && "itemType" in accessor;
}

/**
 * Returns true if the specified collection item is available on the client.
 */
export function isClientItem(item) {
  if (item.serverChangeState === CollectionItemChangeState.REMOVED) {
    return item.clientChangeState === CollectionItemChangeState.ADDED;
  }
  return item.clientChangeState !== CollectionItemChangeState.REMOVED;
}
//# sourceMappingURL=DataValueAccessor.js.map
